import { useEffect, useState } from 'react';
import { EtatJeu } from '../game/types';
import { formatTemps } from '../game/logic';

export const Chrono = ({ etat }: { etat: EtatJeu }) => {
  const [, tick] = useState(0);
  useEffect(() => {
    const t = window.setInterval(() => tick((v) => v + 1), 1000);
    return () => window.clearInterval(t);
  }, []);
  const sec = Math.floor((Date.now() - etat.demarreLe) / 1000) + etat.penalitesSec;
  return (
    <span className="tabular-nums font-semibold text-encre text-lg" data-testid="chrono">
      {formatTemps(sec)}
    </span>
  );
};
